import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAdsOver90DaysProps = {
  clusters?: Array<string>;
  partners?: Array<number>;
  origami?: string;
};
export type FetchAdsOver90Days = (filters: FetchAdsOver90DaysProps) => void;

const fetchAdsOver90Days = ({
  clusters = [],
  partners = [],
  origami,
}: FetchAdsOver90DaysProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    cluster: clusters.length ? "'" + clusters.join("','") + "'" : null,
    partner: partners.join(","),
    enable_origami: origami,
  };
  await fetchReport("ads_over_90_days", dispatch, params);
};

export default fetchAdsOver90Days;
